import { VehicleStatus } from "../Vehicle";
import { DefaultResponseWithData } from "../system";

// Wire values are ints - keep in sync with GPMetals.Core/Entities/PartRequest.cs
export enum PartRequestSource {
  Internal = 0,
  PartPro = 1,
}

export enum PartRequestStatus {
  Open = 0,
  Claimed = 1,
  Fulfilled = 2,
  Closed = 3,
}

export enum PartRequestContactPreference {
  Email = 0,
  Phone = 1,
}

// GPMetals.Core/Helpers/PartRequestRules.cs
export enum PartRequestMatchStrength {
  None = 0,
  Possible = 1,
  Likely = 2,
  Exact = 3,
}

export interface IPartRequestVehicleMatch {
  vehicleId: string;
  vrm: string | null;
  make: string | null;
  model: string | null;
  year: number | null;
  stockNumber: string | null;
  status: VehicleStatus;
  strength: PartRequestMatchStrength;
}

export interface IPartRequestOffer {
  id: string;
  externalConfirmationId: string;
  vendorName: string | null;
  vendorPhone: string | null;
  vendorCity: string | null;
  message: string | null;
  listingId: string | null;
  listingTitle: string | null;
  listingTagNumber: string | null;
  listingUrl: string | null;
  conversationId: string | null;
  offeredAt: string;
}

export interface IPartRequest {
  id: string;
  created: string;
  updated: string | null;

  source: PartRequestSource;
  externalId: string | null;

  vrm: string | null;
  make: string | null;
  model: string | null;
  year: number | null;
  partWanted: string;
  details: string | null;

  status: PartRequestStatus;
  contactPreference: PartRequestContactPreference;

  customerName: string | null;
  customerEmail: string | null;
  customerPhone: string | null;

  externalCreatedAt: string | null;
  requestedAt: string;

  claimedOn: string | null;
  claimedById: string | null;
  claimMessage: string | null;
  conversationId: string | null;

  linkedVehicleId: string | null;
  linkedVehicleVrm: string | null;
  linkedPartId: string | null;
  linkedPartTagNumber: string | null;

  networkExternalId: string | null;
  networkPublishedOn: string | null;
  networkClosedOn: string | null;
  isOnNetwork: boolean;
  canPublishToNetwork: boolean;
  canClaim: boolean;

  createdById: string | null;
  lastSyncedOn: string | null;

  offerCount: number;
  matchedVehicles: IPartRequestVehicleMatch[];
  offers: IPartRequestOffer[];
}

export interface IPartRequestResponse extends DefaultResponseWithData<IPartRequest> {}

/** GET /partrequest/status - drives which PartPro actions the pages show. */
export interface IPartRequestIntegrationStatus {
  featureEnabled: boolean;
  partProConnected: boolean;
}

export interface IPartRequestIntegrationStatusResponse extends DefaultResponseWithData<IPartRequestIntegrationStatus> {}

export interface IPartRequestFilter {
  source?: PartRequestSource;
  status?: PartRequestStatus;
  includeClosed?: boolean;
  onlyMine?: boolean;
  onlyMatched?: boolean;
}

export interface ICreatePartRequest {
  customerName: string;
  customerPhone?: string | null;
  customerEmail?: string | null;
  contactPreference: PartRequestContactPreference;
  vrm?: string | null;
  make?: string | null;
  model?: string | null;
  year?: number | null;
  partWanted: string;
  details?: string | null;
}

export interface IClaimPartRequest {
  message?: string | null;
  vehicleId?: string | null;
  partId?: string | null;
}
